/**
 * @desc: 暂无 
 * @created: 2020/5/18
 * @author: Colorfule
 * @version: v1.0
 */

import request from '@/plugins/http'

// 获取条件查询列表
export const getListData = params => {
  return request.get('/riskExecute/list', params)
}

/** 各项收支列表 (表格数据)
 * params:
 *    limit 天数(30 90 180)
 *    merNo 商户
 *    bankName 渠道
 *    companyId 收单机构/管辖机构
 *    currentPage 当前页
 *    pageSize 每页显示数据
 */
export const getIncomeExpensesList = params => {
  return request.get('/riskExecute/incomeExpensesList', params)
}

/** 收支比(图表)
 * params:
 *    limit 天数(30 90 180)
 *    merNo 商户
 */
export const getIncomeExpensesRatio = params => {
  return request.get('/riskExecute/incomeExpensesRatio', params)
}

/** 收支比 (卡片数据)
 * params:
 *    limit 天数(1 30 90 180)
 *    merNo 商户号
 *    tradeDate 交易日期
 */
export const getIncomeExpensesStatistic = params => {
  return request.get('/riskExecute/incomeExpensesStatistic', params)
}

/** 获取关系链条
 * params:
 *    dateType 日期类型(week/month/year)
 *    no 商户号/供应商号
 *    type 类型 0:商户/1:供应商
 */
export const getRiskExecuteTradeChain = params => {
  return request.get('/riskExecute/tradeChain', params)
}

/**
 * 查询获取原有记录
 * params:
 *    no: 商户号
 */
export const getRiskExecuteHistory = params => {
  return request.get('/riskExecute/getRiskExecute', params)
}

// 添加
export const postSaveNewRiskExecute = data => {
  return request.post('/riskExecute/updateRiskExecute', data, { json: true })
}
